module.exports = __webpack_public_path__ + "res/roulette.d6498aefaa55ad198ec17df0b9aeb276.webp";